// +----------------------------------------------------------------------
// | 忘记密码：填邮箱 → 发重置信
// |
// | 注意文案口径：后端是**防枚举**的 —— 查不到账号、发信失败、触发频控，
// | 统统返回同一句回执。所以这页绝不能写「该邮箱未注册」这类判断，
// | 统一说「如果这个邮箱绑过账号，信已经发出去了」。
// | 这也是业界标准做法：否则这个页面就成了「某邮箱注册过没有」的探测器。
// +----------------------------------------------------------------------
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../../api/auth';
import '../../css/auth.less';

export default function Forgot() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    const mail = email.trim();
    // 前端只拦格式（这跟账号存不存在无关，不泄露信息）
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
      setError('邮箱格式不对，检查一下');
      return;
    }

    setError('');
    setLoading(true);
    try {
      await forgotPassword(mail);
      setDone(true);
    } catch (err) {
      setError(err.message || '发送失败，稍后再试');
    } finally {
      setLoading(false);
    }
  };

  const backToForm = () => {
    setDone(false);
    setError('');
  };

  return (
    <div className="auth">
      <div className="auth-panel">
        <div className="auth-brand">
          <span className="auth-brand-name">想想</span>
          <span className="auth-brand-sub">找回你的账号</span>
        </div>

        {done ? (
          <div className="auth-card">
            <div className="auth-done">
              <div className="auth-done-icon">📮</div>
              <h2 className="auth-done-title">信已经发出去了</h2>
              <p className="auth-done-desc">
                如果 <strong>{email.trim()}</strong> 绑过想想账号，
                <br />
                重置链接就在那个邮箱里，<strong>30 分钟内有效</strong>。
                <br />
                <br />
                没收到的话，翻一下垃圾邮件。
              </p>
            </div>

            <button type="button" className="btn btn-primary btn-block" onClick={backToForm}>
              换个邮箱再试
            </button>

            <div className="auth-switch">
              想起来了？<Link to="/login">回去登录</Link>
            </div>
          </div>
        ) : (
          <form className="auth-card" onSubmit={handleSubmit}>
            <h2 className="title-lg">忘记密码了</h2>
            <p className="muted" style={{ margin: '6px 0 20px' }}>
              填注册时的邮箱，我们给你发一个重置链接。
            </p>

            {error && <div className="auth-error">{error}</div>}

            <div className="field">
              <label htmlFor="email">邮箱</label>
              <input
                id="email"
                className="input"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="注册时填的邮箱"
              />
              <div className="auth-hint">
                没绑过邮箱的账号收不到信，可以登录后在「偏好设置」里补一个。
              </div>
            </div>

            <button type="submit" className="btn btn-primary btn-block auth-submit" disabled={loading}>
              {loading ? '发送中…' : '发送重置链接'}
            </button>

            <div className="auth-switch">
              想起来了？<Link to="/login">回去登录</Link>
            </div>
          </form>
        )}

        <Link to="/" className="auth-back">
          ← 先随便看看
        </Link>
      </div>
    </div>
  );
}
